import { useState } from 'react';
import { Link } from 'react-router';
import type { Project } from '@tallypg/contracts';
import { api, useApi } from '../api';

export function ProjectsPage() {
  const projects = useApi<{ projects: Project[] }>('/projects');
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  return (
    <div>
      <h1>Projects</h1>
      <div className="card">
        <h2>New project</h2>
        <form
          className="row"
          onSubmit={async (e) => {
            e.preventDefault();
            setError(null);
            try {
              await api('/projects', { method: 'POST', json: { name } });
              setName('');
              await projects.reload();
            } catch (err) {
              setError(err instanceof Error ? err.message : 'Failed');
            }
          }}
        >
          <input
            placeholder="my-app"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            maxLength={64}
          />
          <button type="submit">Create</button>
        </form>
        {error && <p className="error">{error}</p>}
      </div>
      <div className="card">
        {projects.data?.projects.length === 0 && (
          <p className="muted">
            A project groups databases (for example production, staging, preview). Create one to get started.
          </p>
        )}
        {projects.data && projects.data.projects.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Databases</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {projects.data.projects.map((p) => (
                <tr key={p.id}>
                  <td>
                    <Link to={`/projects/${p.id}`}>{p.name}</Link>
                  </td>
                  <td>{p.databaseCount}</td>
                  <td>{new Date(p.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
